<template>
    <div>
        <v-container fluid>
            <v-banner single-line sticky>
                <v-alert
                    color="blue-grey darken-3"
                    dense
                    border="bottom"
                    type="primary"
                    icon="mdi-information"
                >
                    <v-row no-gutters>
                        <v-col cols="4"
                            >OPEN NEW CASE {{ showCase.case_id }}</v-col
                        >
                        <v-col v-if="showCase.case_id == ''" cols="4"
                            ><span class="text-color-red"
                                >Last Update : {{ Last_update }}</span
                            ></v-col
                        >
                        <v-col cols="4" class="text-center">
                            <v-chip
                                v-if="showproject != ''"
                                class="orange darken-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showproject }}</h3>
                            </v-chip>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn
                                v-if="visible"
                                class="ma-2"
                                @click="back()"
                                tile
                                color="cyan darken-1"
                                dark
                                >Back</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-alert>
            </v-banner>

            <div v-if="!visible">
                <v-row>
                    <v-col cols="8" sm="4">
                        <v-textarea
                            v-model="findData"
                            auto-grow
                            outlined
                            rows="5"
                            row-height="25"
                            rounded
                            solo
                        ></v-textarea>
                    </v-col>
                    <v-col cols="4" sm="2">
                        <v-btn
                            :loading="loading"
                            :disabled="loading"
                            color="blue-grey"
                            class="white--text"
                            fab
                            @click="findCase()"
                        >
                            <!-- @click="loader = 'loading'" -->
                            <v-icon dark>mdi-cloud-search-outline</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8" sm="4">
                        <v-file-input
                            v-model="files"
                            color="blue darken-4"
                            counter
                            label="อัพโหลดงาน SRFR"
                            multiple
                            small-chips
                            placeholder="Select your files"
                            prepend-icon="mdi-paperclip"
                            :show-size="1000"
                        ></v-file-input>
                    </v-col>
                    <v-col cols="4" sm="2">
                        <v-btn
                            :loading="loading2"
                            :disabled="loading2"
                            color="blue-grey"
                            class="white--text"
                            fab
                            @click="UploadFiles()"
                        >
                            <v-icon dark>mdi-file-upload-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4">
                        <view-alert :alert="alert" v-if="alert.status" />
                    </v-col>
                </v-row>
                <table-view-case
                    v-if="visibleduplicate"
                    :condition="condition"
                    :data_case="data_new"
                    :casetab="casetab"
                />
                <v-row>
                    <v-col :cols="12" v-if="data_case.total > 0">
                        <v-alert
                            dense
                            border="bottom"
                            type="primary"
                            icon="mdi-information"
                            >CASE TODAY</v-alert
                        >
                        <table-view-case
                            :condition="condition"
                            :data_case="data_case"
                            :casetab="casetab"
                        />
                        <div class="text-center pa-5">
                            <v-pagination
                                @input="onPageChange"
                                v-model="pagination.current"
                                :length="data_case.last_page"
                                circle
                            ></v-pagination>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!visiblecase">
                <v-card>
                    <v-form ref="form" v-model="information.valid">
                        <v-information
                            :condition="condition"
                            :information="information"
                        />
                        <!-- <case-information
              :condition="condition"
              :information="information"
            />
            <product-information
              :condition="condition"
              :information="information"
            />
            <customer-information
              :condition="condition"
              :information="information"
            /> -->
                        <engineer-information
                            @showform="validateform"
                            :condition="condition"
                            :information="information"
                        />
                        <part-information
                            :condition="condition"
                            :information="information"
                        />
                    </v-form>
                    <!-- <log-information
                        :condition="condition"
                        :information="information"
          />-->
                    <v-row justify="center">
                        <v-checkbox
                            v-if="condition.team != 'NONHP'"
                            v-model="information.kci"
                            false-value="N"
                            true-value="Y"
                            label="ข้ามขั้นตอน KCI หรือไม่?"
                        ></v-checkbox>
                    </v-row>
                    <v-row justify="center">
                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="vali_chk_save != ''"
                        >
                            <span style="color: red">{{ vali_chk_save }}</span>
                        </v-col>
                        <v-col cols="8" v-if="chk_save_new == true">
                            <v-progress-linear
                                class="ma-10"
                                indeterminate
                                color="cyan"
                            ></v-progress-linear>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="chk_save_new == false"
                        >
                            <v-btn
                                :disabled="!information.valid"
                                @click="saveCase()"
                                class="ma-4"
                                tile
                                color="success"
                            >
                                <v-icon left>mdi-content-save</v-icon>Save
                            </v-btn>
                        </v-col>

                        <!-- <v-btn class="ma-4" tile color="warning">
              <v-icon left>mdi-close-octagon</v-icon>Cancel
            </v-btn>-->
                    </v-row>
                </v-card>
            </div>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"

import firebaseApp from "../../../firebase"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import PartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"
import ViewAlert from "../components/ShowAlert"
import EngineerNewInformation from "../components/EngineerNewInformation"
import Information from "../components/Information"

export default {
    components: {
        "table-view-case": TableViewCase,
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "view-alert": ViewAlert,
        "v-information": Information,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    data() {
        return {
            chk_save_new: false,
            casetab: false,
            vali_chk_save: "",
            data: {},
            information: {},
            defaultInformation: {
                case_title: "",
                case_type: "",
                case_problem_type: "",
                case_sla: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
            },
            condition: {
                team: "OKI",
                status: "ViewDetail",
                project: "",
            },
            findData: "",
            findDetail: {
                case_id: "",
                ponumber: "",
            },
            showproject: "",
            showCase: {
                case_id: "",
            },
            information: {},
            loader: null,
            loading: false,
            loading2: false,
            files: [],
            data_case: [],
            pagination: {
                current: 1,
            },
            visiblecase: true,
            visible: false,
            alert: {
                text: "",
                status: false,
            },
            visibleduplicate: false,
            data_new: [],
            Last_update: "",
        }
    },
    mounted() {
        this.getOwnerTodayCase()
        this.getLastUpdate()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        // onFileSelected(event) {
        //   for (let i = 0; i <n event.length; i++) {
        //     this.files.push(event[i]);
        //   }
        // },
        validateform() {
            this.$refs.form.validate()
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getOwnerTodayCase()
        },
        getOwnerTodayCase: _.debounce(async function(e) {
            this.visibleduplicate = false
            this.casetab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/owner-case-today?page=${this.pagination.current}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.casetab = true
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        async saveCase() {
            this.information.part.map((each) => {
                if (each.part_no == "") {
                    this.information.part = []
                }
            })
            if (this.information.engineer == "ZONE") {
                this.information.dateonsite = ""
            }
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/newcase`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let chk_save
                if (
                    this.information.case_type == "" ||
                    this.information.case_type == null ||
                    this.information.case_type == undefined
                ) {
                    this.vali_chk_save = "**กรุณาเลือก Case Type"
                    chk_save = false
                } else if (
                    this.information.warranty_type == "" ||
                    this.information.warranty_type == null ||
                    this.information.warranty_type == undefined
                ) {
                    this.vali_chk_save = "**กรุณาเลือก Warranty Type"
                    chk_save = false
                } else {
                    chk_save = true
                }

                if (chk_save == true) {
                    this.chk_save_new = true
                    this.mutateIsLoading()
                    let { data, status } = await axios
                        .post(url, this.information, options)
                        .catch(function(error) {
                            swal({
                                title: `Error Message : ${error}`,
                                icon: "error",
                                button: "OK",
                            })
                        })
                    this.chk_save_new = false
                    this.mutateIsLoading()
                    if (status == "200") {
                        this.$swal({
                            title: "บันทึกข้อมูลเรียบร้อย ?",
                            text: "",
                            icon: "success",
                            timer: 3000,
                            dangerMode: true,
                        }).then((del) => {
                            this.visible = false
                            this.visiblecase = true
                            this.showproject = ""
                            this.showCase.case_id = ""
                            this.getOwnerTodayCase()
                            this.findData = ""
                        })
                    }
                }
            } catch (error) {
                console.log(error.message)
            }

            //   var contactRef = firebaseApp.database().ref(`contacts/${this.information.ReferCase}`)
            //   contactRef.set({
            //         casetitle: this.information.casetitle,
            //         jobtype: this.information.jobtype,
            //         proptype : this.information.Probtype
            //   })
        },
        back() {
            this.visible = false
            this.visiblecase = true
            this.showproject = ""
            this.showCase.case_id = ""
        },
        async findCase() {
            var data = this.findData.split("\n")

            this.findDetail.case_id = data[0].trim()
            this.findDetail.ponumber = data.length == 1 ? "" : data[1]
            this.findDetail.type = "OKI"

            try {
                this.information = {}
                const url = `${process.env.VUE_APP_ROOT_API}/api/hp/checkcase`
                const { data } = await axios.post(`${url}`, this.findDetail)

                this.data = data

                if (
                    this.data.error !== undefined &&
                    this.data.error != "manual"
                ) {
                    if (this.data.error == "duplicate case") {
                        var form = {
                            searchtext: this.findDetail.case_id,
                        }
                        const options = {
                            headers: {
                                Authorization: "Bearer " + localStorage.token,
                            },
                        }

                        const url = `${process.env.VUE_APP_ROOT_API}/api/allcase?page=1`

                        const { data } = await axios.post(
                            `${url}`,
                            form,
                            options
                        )
                        this.data_new = data
                        this.visibleduplicate = true
                    } else {
                        this.alert = {
                            text: this.data.error,
                            status: true,
                        }
                        this.showproject = ""
                    }
                } else {
                    this.alert = {
                        text: "",
                        status: false,
                    }
                    this.showproject = "OKI"

                    this.condition.project = this.findDetail.type

                    this.visible = true
                    this.visiblecase = false
                    this.showCase.case_id = this.data.caseid
                    this.information = {
                        case_type: "",
                        case_problem_type: "",
                        problem_type: [
                            {
                                problem_type_name: "Hardware",
                                problem_type_id: "4",
                            },
                            {
                                problem_type_name: "Software",
                                problem_type_id: "5",
                            },
                            {
                                problem_type_name: "Monitor",
                                problem_type_id: "13",
                            },
                        ],
                        case_sla:
                            this.data.sla != undefined ? this.data.sla : "",
                        case_sla_date: "",
                        case_sla_time: "",
                        remark:
                            this.data.remark != undefined
                                ? this.data.remark
                                : "",
                        subcase_title:
                            this.data.casetitle != undefined
                                ? this.data.casetitle
                                : "",
                        site_district_id: "",
                        site_amphur_id: "",
                        site_province_id: "",
                        log_type: "",
                        log_note: "",
                        product_description: "",
                        branch_id: "",
                        engineer: "",
                        case_id: this.data.caseid,
                        case_title:
                            this.data.casetitle != undefined
                                ? this.data.casetitle
                                : "",
                        customer_name:
                            this.data.firstname != undefined &&
                            this.data.lastname != undefined
                                ? this.data.firstname + " " + this.data.lastname
                                : "",
                        customer_tel:
                            this.data.tel != undefined ? this.data.tel : "",
                        customer_email:
                            this.data.email != undefined ? this.data.email : "",
                        site_name:
                            this.data.companyname != undefined &&
                            this.data.companyname != ""
                                ? this.data.companyname
                                : this.data.firstname != undefined &&
                                  this.data.lastname != undefined
                                ? this.data.firstname + " " + this.data.lastname
                                : "",
                        site_address:
                            this.data.address != undefined
                                ? this.data.address
                                : "",
                        site_postcode:
                            this.data.postalcode != undefined &&
                            this.data.postalcode.length == "5"
                                ? this.data.postalcode + "x"
                                : "",
                        product_group:
                            this.data.productgroup != undefined
                                ? this.data.productgroup
                                : "",
                        product_line:
                            this.data.productline != undefined
                                ? this.data.productline
                                : "",
                        product_no:
                            this.data.productno != undefined
                                ? this.data.productno
                                : "",
                        product_serial:
                            this.data.serial != undefined
                                ? this.data.serial
                                : "",
                        product_description:
                            this.data.productdescription != undefined
                                ? this.data.productdescription
                                : "",
                        part: [],
                    }
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async UploadFiles() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            try {
                let formData = new FormData()
                const url = `${process.env.VUE_APP_ROOT_API}/api/srfr/upload`

                if (undefined !== this.files && this.files.length > 0) {
                    for (let i = 0; i < this.files.length; i++) {
                        formData.append(`files[${i}]`, this.files[i])
                    }

                    const { data, status } = await axios.post(
                        url,
                        formData,
                        options
                    )

                    if (status == "200") {
                        swal({
                            title: "Upload Complete",
                            icon: "success",
                            button: "OK",
                        })

                        this.files = []
                    } else {
                        swal({
                            title: "Upload error",
                            icon: "error",
                            button: "OK",
                        })
                    }
                } else {
                    swal({
                        title: "กรุณาเลือกไฟล์ !!",
                        icon: "error",
                        button: "OK",
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getLastUpdate() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/last-updated`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const { data } = await axios.get(`${url}`, options)
            this.Last_update = data.last_updated
        },
    },
}
</script>

<style scoped>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}

.v-banner__text {
    width: 1150px;
}
</style>
